import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BRANCH_OFFICE_URL, WHATSAPP_URL } from '@constants/business.constant';
import { URL_CONTACTO_TRAMITE_PENSION } from '@constants/url.constant';

interface IHelpLink {
  label: string;
  url: string;
  target: '_self' | '_blank';
  internalRoute?: string;
}

@Component({
  selector: 'app-help-links',
  templateUrl: './help-links.component.html',
  styleUrl: './help-links.component.scss',
  standalone: true,
  imports: [NgFor],
})
export class HelpLinksComponent {

  constructor(private readonly router: Router) { }

  public readonly links: IHelpLink[] = [
    {
      label: 'Llámanos al 600 6600 900',
      url: 'tel:6006600900',
      target: '_self',
    },
    {
      label: 'Escríbenos a WhatsApp',
      url: WHATSAPP_URL,
      target: '_blank',
    },
    {
      label: 'Formulario de Contacto',
      url: URL_CONTACTO_TRAMITE_PENSION,
      target: '_self',
      internalRoute: URL_CONTACTO_TRAMITE_PENSION,
    },
    {
      label: 'Sucursales y Centros de Servicio',
      url: BRANCH_OFFICE_URL,
      target: '_blank',
    },
  ];

  public onLinkClick(event: MouseEvent, link: IHelpLink): void {
    if (!link.internalRoute) {
      return;
    }

    event.preventDefault();
    this.router.navigate([link.internalRoute]);
  }
}
